import type { FC } from "react";
import styled from "styled-components";
import { translate } from "app/filters/i18nFilter";
import { LoaderContainer, LoadingSpinner } from "app/pages/keyword-analysis/TotalTrafficPage/StyledComponents";
import type { ETotalScore } from "../../common/types";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { getDifficultyStatusColor, getDifficultyStatusName } from "../../utils/utils";

const { carbon } = colorsPalettes;

const DifficultyStatusWrapper = styled.div`
    text-align: center;
`;

const StatusContainer = styled.div<{ color: string }>`
    background-color: ${({ color }) => `${color}`};
    padding: 4px 12px;
    box-sizing: border-box;
    ${setFontVariant("h3", carbon[0])};
    border-radius: 4px;
    margin: 0 auto;
    width: fit-content;
`;

const LableContainer = styled.div`
    margin-top: 12px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 0 10px;
`;

const Lable = styled.div`
    ${setFontVariant("subTitle3Alt", carbon[500])};
`;

const SubLable = styled.div`
    ${setFontVariant("listItem3", carbon[300])};
`;

interface IDifficultyStatus {
    status: ETotalScore;
    isLoading?: boolean;
}

const DifficultyStatus: FC<IDifficultyStatus> = ({ status, isLoading }) => {
    return (
        <DifficultyStatusWrapper data-automation="DifficultyStatus">
            {isLoading ? (
                <LoaderContainer>
                    <LoadingSpinner />
                </LoaderContainer>
            ) : (
                <div>
                    <StatusContainer color={getDifficultyStatusColor(status)}>
                        {getDifficultyStatusName(status)}
                    </StatusContainer>
                    <LableContainer>
                        <Lable>{translate("industryoverview.market.difficulty.status.lable")}</Lable>
                        <SubLable>{translate("industryoverview.market.difficulty.status.sublable")}</SubLable>
                    </LableContainer>
                </div>
            )}
        </DifficultyStatusWrapper>
    );
};

export default DifficultyStatus;
